export default class WindDirectionUtil {
  static WIND_DIRECTION_NAMES_8 = [
    '北风',
    '东北风',
    '东风',
    '东南风',
    '南风',
    '西南风',
    '西风',
    '西北风'
  ]

  wdns

  constructor (windDirectionNames) {
    this.wdns = [...windDirectionNames]
  }

  getWindDirName (angle) {
    const { wdns } = this
    const len = wdns.length
    const interval = 360 / len
    const offset = interval / 2
    return wdns[Math.floor(((angle + offset) % 360) / interval)]
  }
}



// WEBPACK FOOTER //
// ./src/model/WindDirectionUtil.js